import { useEffect, useState } from 'react';
import { getJson } from '../lib/api.js';

// Public example LiveDecks for the examples grid.
//
// /api/examples takes an optional bearer token and, when it gets one, adds the
// lectures from classes the user is enrolled in on top of the public list. The
// pre-React page fetched it without the token and so only ever showed the public
// ones; passing it here is what the endpoint was built for. Refetches on sign-in
// and sign-out because the answer genuinely differs.
//
// `ready` holds the request until the session has been resolved: firing while
// useAuth is still checking would fetch once anonymously and then again with the
// token a moment later, and the first answer is the wrong one.
export function useExamples(token, ready) {
  const [lectures, setLectures] = useState([]);

  useEffect(() => {
    if (!ready) return undefined;
    let cancelled = false;
    getJson('/api/examples', token)
      .then(({ ok, data }) => {
        if (!cancelled && ok) setLectures(data.lectures || []);
      })
      .catch((err) => {
        console.error('Failed to load examples:', err);
      });
    return () => {
      cancelled = true;
    };
  }, [token, ready]);

  return lectures;
}
